import BASIC_CONSTANT from 'constants/basic.constants.js/basic.constants.js';
import React, { useEffect, useState } from 'react';
import ChannelClass from 'classes/ChannelClass';
import PropTypes from 'prop-types';
import { withTranslation } from 'utils/with-i18next';
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogFooter,
} from '@/components/ui/dialog';
import { Button } from '@/components/ui/Button';
import { Input } from '@/components/ui/Input';
import { Camera } from 'lucide-react';

const CreateChannel = props => {
  const [state, setState] = useState({
    value: '',
    valueLength: 0,
  });
  const [url, setUrl] = useState(null);
  const [random, setRandom] = useState(null);
  const token = localStorage.getItem(BASIC_CONSTANT.USER_TOKEN_KEY);
  const channel = new ChannelClass();
  const [imgFile, setImgFile] = useState(null);

  useEffect(() => {
    randomThumnail();
  }, []);

  const randomThumnail = async () => {
    const result = await channel.getProfileImages(token);
    if (result) {
      const imgNum = Math.floor(Math.random() * 20);
      const random = result[imgNum].slice(1);
      const thumbnail = random.indexOf('https://') !== -1 ? random : BASIC_CONSTANT.BASE_URL + random;
      setRandom(thumbnail);
    }
  };

  const selectImage = e => {
    let file = e.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => {
        setUrl(reader.result);
      };
      setImgFile(file);
    }
  };

  const onClick = () => {
    const target = document.getElementById('selectUrl');
    target.click();
  };

  const createChannel = async () => {
    const result = await channel.postChannels(state.value, random, imgFile, token);
    if (result) {
      props.setCreatedList(result);
      props.setStatePopUp(false);
    }
  };

  const onChangeHandle = e => {
    if (e.target.value.length <= 20) {
      setState({ value: e.target.value, valueLength: e.target.value.length });
    }
  };
  const t = props.t;

  return (
    <Dialog open={props.statePopUp} onOpenChange={props.setStatePopUp}>
      <DialogContent className="sm:max-w-md">
        <DialogHeader>
          <DialogTitle className="text-2xl font-bold text-center">
            {t('createChannel')}
          </DialogTitle>
        </DialogHeader>

        <div className="space-y-6 py-4">
          {/* Image Selection */}
          <div className="flex flex-col items-center gap-4">
            <input
              id="selectUrl"
              type="file"
              name="file"
              accept="image/jpg,image/jpeg,.png"
              onChange={selectImage}
              className="hidden"
            />
            <div
              onClick={onClick}
              className="relative w-32 h-32 rounded-full overflow-hidden cursor-pointer group border-4 border-gray-800 hover:border-primary/50 transition-all duration-300"
              style={{
                backgroundImage: `url(${url ? url : random})`,
                backgroundSize: 'cover',
                backgroundPosition: 'center'
              }}
            >
              <div className="absolute inset-0 bg-black/40 group-hover:bg-black/60 transition-all duration-300 flex items-center justify-center">
                <div className="bg-primary/90 rounded-full p-3 group-hover:scale-110 transition-transform duration-300">
                  <Camera className="w-6 h-6 text-black" />
                </div>
              </div>
            </div>
            <p className="text-sm text-muted-foreground">
              Click to upload channel image
            </p>
          </div>

          {/* Channel Name Input */}
          <div className="space-y-2">
            <label htmlFor="createName" className="text-sm font-medium text-foreground">
              Channel Name
            </label>
            <Input
              id="createName"
              value={state.value}
              onChange={onChangeHandle}
              placeholder={t('CreateChannel.inputPlaceholer')}
              onKeyDown={e => e.keyCode === 13 && state.value.trim().length > 0 && createChannel()}
              className="w-full"
            />
            <div className="flex justify-end">
              <span className="text-xs text-muted-foreground">
                {state.valueLength}/20
              </span>
            </div>
          </div>
        </div>

        <DialogFooter className="gap-2">
          <Button
            variant="outline"
            onClick={() => props.setStatePopUp(false)}
          >
            Cancel
          </Button>
          <Button
            id="create-button"
            disabled={state.valueLength === 0}
            onClick={createChannel}
            className="min-w-[100px]"
          >
            {t('create')}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};

CreateChannel.propTypes = {
  t: PropTypes.func,
};

export default withTranslation('myChannel')(CreateChannel);
